// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/DrupalCountdown.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/DrupalCountdown.tsx");
  import.meta.hot.lastModified = "1732036225891.6086";
}
// REMIX HMR END

import Countdown from "../Countdown";
export default function DrupalCountdown() {
  return <Countdown endDate={new Date(2025, 0, 5, 0, 0, 0)} title="How much time is left until the Drupal 7 End of Life (EOL)?" />;
}
_c = DrupalCountdown;
var _c;
$RefreshReg$(_c, "DrupalCountdown");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;